// extracted by mini-css-extract-plugin
module.exports = {"img":"styles_img__1Q06j","container":"styles_container__d38tt"};